import api from "../utils/api";

export const list = (category) => async (dispatch) => {
    try {
        const res = await api.get(`/codes/c/${category}`);
        return res.data;
    } catch (err) {
        console.error("Unable to load license codes.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};
